// Mini-ficha al pasar sobre cada marca del marquee de TRAYECTORIA (solo /resultados/).
// No-op si la página no tiene .lmarquee. Táctil: tap alterna la ficha.

type Ficha = { tag: string; desc?: string }

const FICHAS: Record<string, Ficha> = {
  'SQM': { tag: 'Minería · corporativo', desc: 'Marketing de contenidos y notas de prensa para una iniciativa específica.' },
  'Teleduc UC': { tag: 'Educación · e-commerce', desc: 'Primer e-commerce Shopify de una universidad chilena.' },
  'Ministerio de Turismo · Rep. Dominicana': { tag: 'Turismo · gobierno', desc: 'Portal turístico nacional con visualización 3D en Three.js.' },
  'Hautarzt Uribe & Holmgren': { tag: 'Salud · internacional', desc: 'Clínica dermatológica trilingüe, +300 páginas y GDPR, en Hamburgo.' },
  'Farmacia Kenko': { tag: 'Farmacia · e-commerce', desc: 'Farmacia online: tienda y catálogo en e-commerce.' },
  'Farmagran': { tag: 'Salud · e-commerce', desc: 'Farmacia online con validación de recetas y checkout a medida en Shopify.' },
  'CIREN': { tag: 'Recursos naturales · gobierno', desc: 'Portal institucional para datos técnicos y series históricas.' },
  'GlobalMetrics': { tag: 'Tecnología · marketing', desc: 'Marketing digital para la plataforma de analítica y gestión de riesgo.' },
  'Innspiral': { tag: 'Innovación · diseño web', desc: 'Diseño completo del sitio web de la consultora de innovación corporativa.' },
  'Hobbiegames': { tag: 'Juegos · e-commerce', desc: 'E-commerce de juegos de mesa con catálogo escalable.' },
  'La Tabla de Toro': { tag: 'Gastronomía' },
  'Wenel': { tag: 'Campañas digitales' },
  'CNA Fertiamerica': { tag: 'Agrícola · corporativo', desc: 'Sitio web corporativo con fichas técnicas de fertilizantes.' },
  'QAD': { tag: 'Software · corporativo', desc: 'Sitio corporativo B2B para proveedor global de software.' },
  'Hub Tarapacá': { tag: 'Regional · marketing digital', desc: 'Marketing digital, email y RRSS para el ecosistema de innovación de Tarapacá.' },
  'RCTEC': { tag: 'Tecnología · branding', desc: 'Identidad visual y sitio corporativo para soluciones informáticas.' },
  'Impresionarte': { tag: 'Imprenta · marketing', desc: 'Marketing digital y contenido para empresa de impresión y diseño.' },
  'Bijou': { tag: 'Moda · e-commerce', desc: 'Marketing y publicidad para tienda de moda online.' },
  'SimplyB': { tag: 'Retail · e-commerce', desc: 'Marketing digital y captación de clientes para tienda online.' },
  'Arichy Real Estate · Rep. Dominicana': { tag: 'Inmobiliaria · internacional', desc: 'Plataforma de compra, venta y arriendo en República Dominicana.' },
}

export function initMarqueeModal(): void {
  const marquee = document.querySelector<HTMLElement>('.lmarquee')
  if (!marquee) return

  const pop = document.createElement('div')
  pop.className = 'lmarquee-pop'
  pop.setAttribute('role', 'tooltip')
  const nameEl = document.createElement('span')
  nameEl.className = 'lmarquee-pop__name'
  const tagEl = document.createElement('span')
  tagEl.className = 'lmarquee-pop__tag'
  const descEl = document.createElement('span')
  descEl.className = 'lmarquee-pop__desc'
  pop.append(nameEl, tagEl, descEl)
  document.body.appendChild(pop)

  let current: HTMLElement | null = null

  const position = (span: HTMLElement): void => {
    const r = span.getBoundingClientRect()
    const pr = pop.getBoundingClientRect()
    let left = r.left + r.width / 2 - pr.width / 2
    left = Math.max(12, Math.min(left, window.innerWidth - pr.width - 12))
    let top = r.top - pr.height - 12
    if (top < 12) top = r.bottom + 12 // si no cabe arriba, abajo
    pop.style.left = `${left}px`
    pop.style.top = `${top}px`
  }

  const show = (span: HTMLElement): void => {
    const name = (span.textContent || '').trim()
    const f = FICHAS[name]
    if (!f) { hide(); return }
    nameEl.textContent = name
    tagEl.textContent = f.tag
    descEl.textContent = f.desc || ''
    descEl.style.display = f.desc ? '' : 'none'
    pop.classList.add('is-visible')
    position(span)
    current = span
  }

  const hide = (): void => {
    pop.classList.remove('is-visible')
    current = null
  }

  const spans = marquee.querySelectorAll<HTMLElement>('.lmarquee__track > span:not(.lmarquee__more)')
  spans.forEach((span) => {
    span.addEventListener('mouseenter', () => show(span))
    span.addEventListener('mouseleave', hide)
  })

  // Táctil: tap alterna la ficha del nombre tocado
  marquee.addEventListener('click', (e) => {
    const span = (e.target as HTMLElement).closest<HTMLElement>('.lmarquee__track > span:not(.lmarquee__more)')
    if (!span) { hide(); return }
    if (current === span) hide()
    else show(span)
  })

  window.addEventListener('scroll', hide, { passive: true })
  window.addEventListener('resize', hide)
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hide() })
}
